/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BackendTypesEnum } from './BackendTypesEnum';
import {
    BackendTypesEnumFromJSON,
    BackendTypesEnumFromJSONTyped,
    BackendTypesEnumToJSON,
} from './BackendTypesEnum';
import type { ClusterStateEnum } from './ClusterStateEnum';
import {
    ClusterStateEnumFromJSON,
    ClusterStateEnumFromJSONTyped,
    ClusterStateEnumToJSON,
} from './ClusterStateEnum';
import type { ClusterTag } from './ClusterTag';
import {
    ClusterTagFromJSON,
    ClusterTagFromJSONTyped,
    ClusterTagToJSON,
} from './ClusterTag';
import type { ClusterTypeEnum } from './ClusterTypeEnum';
import {
    ClusterTypeEnumFromJSON,
    ClusterTypeEnumFromJSONTyped,
    ClusterTypeEnumToJSON,
} from './ClusterTypeEnum';
import type { CustomGroupSchema } from './CustomGroupSchema';
import {
    CustomGroupSchemaFromJSON,
    CustomGroupSchemaFromJSONTyped,
    CustomGroupSchemaToJSON,
} from './CustomGroupSchema';
import type { MetricFlag } from './MetricFlag';
import {
    MetricFlagFromJSON,
    MetricFlagFromJSONTyped,
    MetricFlagToJSON,
} from './MetricFlag';
import type { ProcessStateEnum } from './ProcessStateEnum';
import {
    ProcessStateEnumFromJSON,
    ProcessStateEnumFromJSONTyped,
    ProcessStateEnumToJSON,
} from './ProcessStateEnum';
import type { TagAlertHitSchema } from './TagAlertHitSchema';
import {
    TagAlertHitSchemaFromJSON,
    TagAlertHitSchemaFromJSONTyped,
    TagAlertHitSchemaToJSON,
} from './TagAlertHitSchema';
import type { WorkerByTypeSchema } from './WorkerByTypeSchema';
import {
    WorkerByTypeSchemaFromJSON,
    WorkerByTypeSchemaFromJSONTyped,
    WorkerByTypeSchemaToJSON,
} from './WorkerByTypeSchema';

/**
 * 
 * @export
 * @interface ListNotebookV2
 */
export interface ListNotebookV2 {
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    accountSlug: string;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    accountName: string;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    accountId: number;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    creatorUsername: string;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    creatorId: number;
    /**
     * 
     * @type {ClusterStateEnum}
     * @memberof ListNotebookV2
     */
    state: ClusterStateEnum;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    reason: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListNotebookV2
     */
    staffHasSeen: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    organizationFeatureTier?: string;
    /**
     * 
     * @type {BackendTypesEnum}
     * @memberof ListNotebookV2
     */
    backendType: BackendTypesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ListNotebookV2
     */
    coiledHosted: boolean;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    senvAliasId?: number;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    senvBuildId?: number;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    softwareEnvironmentName?: string;
    /**
     * 
     * @type {ProcessStateEnum}
     * @memberof ListNotebookV2
     */
    schedulerState: ProcessStateEnum;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    workerAcceleratorType?: string;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    workerAcceleratorCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    desiredWorkers: number;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    runningWorkers: number;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    totalWorkers: number;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    regionName?: string;
    /**
     * 
     * @type {Array<WorkerByTypeSchema>}
     * @memberof ListNotebookV2
     */
    workerTypes: Array<WorkerByTypeSchema>;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    dashboardAddress?: string;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    nTasks?: number;
    /**
     * 
     * @type {Array<ClusterTag>}
     * @memberof ListNotebookV2
     */
    tagList: Array<ClusterTag>;
    /**
     * 
     * @type {Array<TagAlertHitSchema>}
     * @memberof ListNotebookV2
     */
    alertList: Array<TagAlertHitSchema>;
    /**
     * 
     * @type {Array<MetricFlag>}
     * @memberof ListNotebookV2
     */
    metricFlags: Array<MetricFlag>;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    costPerHour?: number;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    totalCost?: number;
    /**
     * 
     * @type {Date}
     * @memberof ListNotebookV2
     */
    lastSeen?: Date;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    billableTime?: number;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    approximateCloudCostPerHour?: number;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    approximateCloudTotalCost?: number;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    approximateCloudCostVersion: number;
    /**
     * 
     * @type {CustomGroupSchema}
     * @memberof ListNotebookV2
     */
    dealStageGroup?: CustomGroupSchema;
    /**
     * 
     * @type {boolean}
     * @memberof ListNotebookV2
     */
    pauseOnExit?: boolean;
    /**
     * 
     * @type {ClusterTypeEnum}
     * @memberof ListNotebookV2
     */
    clusterType?: ClusterTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ListNotebookV2
     */
    privateToCreator: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    schedulerTypeName: string;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    approximateMonthlySchedulerDiskCost?: number;
    /**
     * 
     * @type {number}
     * @memberof ListNotebookV2
     */
    schedulerDiskSize?: number;
    /**
     * 
     * @type {string}
     * @memberof ListNotebookV2
     */
    idleTimeout?: string;
}

/**
 * Check if a given object implements the ListNotebookV2 interface.
 */
export function instanceOfListNotebookV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "accountSlug" in value;
    isInstance = isInstance && "accountName" in value;
    isInstance = isInstance && "accountId" in value;
    isInstance = isInstance && "creatorUsername" in value;
    isInstance = isInstance && "creatorId" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "staffHasSeen" in value;
    isInstance = isInstance && "backendType" in value;
    isInstance = isInstance && "coiledHosted" in value;
    isInstance = isInstance && "schedulerState" in value;
    isInstance = isInstance && "desiredWorkers" in value;
    isInstance = isInstance && "runningWorkers" in value;
    isInstance = isInstance && "totalWorkers" in value;
    isInstance = isInstance && "workerTypes" in value;
    isInstance = isInstance && "tagList" in value;
    isInstance = isInstance && "alertList" in value;
    isInstance = isInstance && "metricFlags" in value;
    isInstance = isInstance && "approximateCloudCostVersion" in value;
    isInstance = isInstance && "privateToCreator" in value;
    isInstance = isInstance && "schedulerTypeName" in value;

    return isInstance;
}

export function ListNotebookV2FromJSON(json: any): ListNotebookV2 {
    return ListNotebookV2FromJSONTyped(json, false);
}

export function ListNotebookV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ListNotebookV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'accountSlug': json['account_slug'],
        'accountName': json['account_name'],
        'accountId': json['account_id'],
        'creatorUsername': json['creator_username'],
        'creatorId': json['creator_id'],
        'state': ClusterStateEnumFromJSON(json['state']),
        'reason': json['reason'],
        'staffHasSeen': json['staff_has_seen'],
        'organizationFeatureTier': !exists(json, 'organization_feature_tier') ? undefined : json['organization_feature_tier'],
        'backendType': BackendTypesEnumFromJSON(json['backend_type']),
        'coiledHosted': json['coiled_hosted'],
        'senvAliasId': !exists(json, 'senv_alias_id') ? undefined : json['senv_alias_id'],
        'senvBuildId': !exists(json, 'senv_build_id') ? undefined : json['senv_build_id'],
        'softwareEnvironmentName': !exists(json, 'software_environment_name') ? undefined : json['software_environment_name'],
        'schedulerState': ProcessStateEnumFromJSON(json['scheduler_state']),
        'workerAcceleratorType': !exists(json, 'worker_accelerator_type') ? undefined : json['worker_accelerator_type'],
        'workerAcceleratorCount': !exists(json, 'worker_accelerator_count') ? undefined : json['worker_accelerator_count'],
        'desiredWorkers': json['desired_workers'],
        'runningWorkers': json['running_workers'],
        'totalWorkers': json['total_workers'],
        'regionName': !exists(json, 'region_name') ? undefined : json['region_name'],
        'workerTypes': ((json['worker_types'] as Array<any>).map(WorkerByTypeSchemaFromJSON)),
        'dashboardAddress': !exists(json, 'dashboard_address') ? undefined : json['dashboard_address'],
        'nTasks': !exists(json, 'n_tasks') ? undefined : json['n_tasks'],
        'tagList': ((json['tag_list'] as Array<any>).map(ClusterTagFromJSON)),
        'alertList': ((json['alert_list'] as Array<any>).map(TagAlertHitSchemaFromJSON)),
        'metricFlags': ((json['metric_flags'] as Array<any>).map(MetricFlagFromJSON)),
        'costPerHour': !exists(json, 'cost_per_hour') ? undefined : json['cost_per_hour'],
        'totalCost': !exists(json, 'total_cost') ? undefined : json['total_cost'],
        'lastSeen': !exists(json, 'last_seen') ? undefined : (new Date(json['last_seen'])),
        'billableTime': !exists(json, 'billable_time') ? undefined : json['billable_time'],
        'approximateCloudCostPerHour': !exists(json, 'approximate_cloud_cost_per_hour') ? undefined : json['approximate_cloud_cost_per_hour'],
        'approximateCloudTotalCost': !exists(json, 'approximate_cloud_total_cost') ? undefined : json['approximate_cloud_total_cost'],
        'approximateCloudCostVersion': json['approximate_cloud_cost_version'],
        'dealStageGroup': !exists(json, 'deal_stage_group') ? undefined : CustomGroupSchemaFromJSON(json['deal_stage_group']),
        'pauseOnExit': !exists(json, 'pause_on_exit') ? undefined : json['pause_on_exit'],
        'clusterType': !exists(json, 'cluster_type') ? undefined : ClusterTypeEnumFromJSON(json['cluster_type']),
        'privateToCreator': json['private_to_creator'],
        'schedulerTypeName': json['scheduler_type_name'],
        'approximateMonthlySchedulerDiskCost': !exists(json, 'approximate_monthly_scheduler_disk_cost') ? undefined : json['approximate_monthly_scheduler_disk_cost'],
        'schedulerDiskSize': !exists(json, 'scheduler_disk_size') ? undefined : json['scheduler_disk_size'],
        'idleTimeout': !exists(json, 'idle_timeout') ? undefined : json['idle_timeout'],
    };
}

export function ListNotebookV2ToJSON(value?: ListNotebookV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'account_slug': value.accountSlug,
        'account_name': value.accountName,
        'account_id': value.accountId,
        'creator_username': value.creatorUsername,
        'creator_id': value.creatorId,
        'state': ClusterStateEnumToJSON(value.state),
        'reason': value.reason,
        'staff_has_seen': value.staffHasSeen,
        'organization_feature_tier': value.organizationFeatureTier,
        'backend_type': BackendTypesEnumToJSON(value.backendType),
        'coiled_hosted': value.coiledHosted,
        'senv_alias_id': value.senvAliasId,
        'senv_build_id': value.senvBuildId,
        'software_environment_name': value.softwareEnvironmentName,
        'scheduler_state': ProcessStateEnumToJSON(value.schedulerState),
        'worker_accelerator_type': value.workerAcceleratorType,
        'worker_accelerator_count': value.workerAcceleratorCount,
        'desired_workers': value.desiredWorkers,
        'running_workers': value.runningWorkers,
        'total_workers': value.totalWorkers,
        'region_name': value.regionName,
        'worker_types': ((value.workerTypes as Array<any>).map(WorkerByTypeSchemaToJSON)),
        'dashboard_address': value.dashboardAddress,
        'n_tasks': value.nTasks,
        'tag_list': ((value.tagList as Array<any>).map(ClusterTagToJSON)),
        'alert_list': ((value.alertList as Array<any>).map(TagAlertHitSchemaToJSON)),
        'metric_flags': ((value.metricFlags as Array<any>).map(MetricFlagToJSON)),
        'cost_per_hour': value.costPerHour,
        'total_cost': value.totalCost,
        'last_seen': value.lastSeen === undefined ? undefined : (value.lastSeen.toISOString()),
        'billable_time': value.billableTime,
        'approximate_cloud_cost_per_hour': value.approximateCloudCostPerHour,
        'approximate_cloud_total_cost': value.approximateCloudTotalCost,
        'approximate_cloud_cost_version': value.approximateCloudCostVersion,
        'deal_stage_group': CustomGroupSchemaToJSON(value.dealStageGroup),
        'pause_on_exit': value.pauseOnExit,
        'cluster_type': ClusterTypeEnumToJSON(value.clusterType),
        'private_to_creator': value.privateToCreator,
        'scheduler_type_name': value.schedulerTypeName,
        'approximate_monthly_scheduler_disk_cost': value.approximateMonthlySchedulerDiskCost,
        'scheduler_disk_size': value.schedulerDiskSize,
        'idle_timeout': value.idleTimeout,
    };
}

